var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as AromaticNoteFactory from '../../../classes/definitions/product/aromaticNote';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import aromaticNoteSchema from '../../../schemas/aromaticNoteSchema';
import Input from '../../UI/Input/Input';
var AromaticNoteForm = /** @class */ (function (_super) {
    __extends(AromaticNoteForm, _super);
    function AromaticNoteForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.productId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(aromaticNoteSchema),
            formIsValid: false,
        };
        _this.getAromaticNoteTypes = function () {
            _this.api
                .getAromaticNoteTypes(_this.productId)
                .then(function (response) {
                _this.setAromaticNoteTypesDropdown(_.get(response, 'data.note_types', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка с извличане на типовете ароматни нотки.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setAromaticNoteTypesDropdown = function (types) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig['note_type']);
            updatedFormElement.elementConfig.options = [];
            for (var key in types) {
                if (Object.prototype.hasOwnProperty.call(types, key)) {
                    // const type = types[key];
                    updatedFormElement.elementConfig.options.push({
                        label: NotosService.formatAromaticNoteTypes(key),
                        value: key,
                    });
                }
            }
            _this.setState({ formConfig: updatedFormConfig });
            // this.editId = _.get(this.props, 'match.params.noteId', '-1');
            // if (this.editId !== '-1') {
            //     this.getAromaticNoteType(this.productId, this.editId);
            // }
        };
        _this.getAromaticNoteType = function (productId, filterOptionId) {
            _this.api
                .getAromaticNote(productId, filterOptionId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на ароматна нотка';
                var currentErrorMessage = _.get(error, 'response.data.errors[0]', '');
                _this.http.handleError(error, _this.messages, currentErrorMessage ? currentErrorMessage : defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var aromaticNote = AromaticNoteFactory.createAromaticNote(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'value.value', aromaticNote.Value);
            _.set(updatedFormConfig, 'value.touched', true);
            _.set(updatedFormConfig, 'value.valid', true);
            _.set(updatedFormConfig, 'en_value.value', aromaticNote.Envalu);
            _.set(updatedFormConfig, 'en_value.touched', true);
            _.set(updatedFormConfig, 'en_value.valid', true);
            _.set(updatedFormConfig, 'note_type.value', aromaticNote.NoteType);
            _.set(updatedFormConfig, 'note_type.touched', true);
            _.set(updatedFormConfig, 'note_type.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedAromaticNote = AromaticNoteFactory.createAromaticNote({
                value: _.get(formData, 'value.value', ''),
                en_value: _.get(formData, 'en_value.value', ''),
                note_type: _.get(formData, 'note_type.value', ''),
            });
            var actionMethod = _this.api.createAromaticNote; // this.editId === '-1' ? this.api.createAromaticNote : null; // this.api.updateFilterOption;
            actionMethod(submittedAromaticNote, _this.productId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toAromaticNotePage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на ароматна нотка';
                var currentErrorMessage = _.get(error, 'response.data.errors[0]', '');
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history, currentErrorMessage);
            });
        };
        _this.toAromaticNotePage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.productId + AppRoutes.aromaticNotes.path);
        };
        return _this;
    }
    AromaticNoteForm.prototype.componentDidMount = function () {
        this.productId = _.get(this.props, 'match.params.id', '-1');
        this.getAromaticNoteTypes();
    };
    AromaticNoteForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toAromaticNotePage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return AromaticNoteForm;
}(React.Component));
// @ts-ignore
export default withRouter(AromaticNoteForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/AromaticNotes/AromaticNoteForm/AromaticNoteForm.tsx
// module id = 317
// module chunks = 0